import type { MembershipPlanType } from "@features/membership/model/types";

// 아이콘을 사용하는 플랜만 매핑 (Virtual Address/Day Pass는 아이콘 없음)
export const PLAN_ICON_SRC: Record<Exclude<MembershipPlanType, "VIRTUAL_ADDRESS" | "DAY_PASS">, string> = {
  SILVER: "/assets/silver_icon.svg",
};
